import { AbstractFeatureChildService } from '@y42/feature';
import { AbstractGitEntityState } from '@y42/feature/git/state';
import { getJSONSchemaURL } from '@y42/feature/json-schema';
import { DataTest } from '../state/data-test.model';
import { DataTestable } from '../state/data-testable.model';

export abstract class DataTestService<T extends DataTestable = DataTestable> {
  constructor(private readonly service: AbstractFeatureChildService<AbstractGitEntityState<T>>) {}

  async create(params: CreateOrUpdateDataTestParams) {
    await this.writeTests(params);
  }

  async update(params: CreateOrUpdateDataTestParams): Promise<void> {
    await this.writeTests(params);
  }

  private writeTests({ tests, datasourceTablePath }: CreateOrUpdateDataTestParams): Promise<void> {
    return this.service.update(
      {
        tests: {
          $schema: getJSONSchemaURL('data-test-settings'),
          tests,
        },
      } as T,
      datasourceTablePath,
    );
  }
}

export interface CreateOrUpdateDataTestParams {
  datasourceTablePath: string;
  tests: DataTest[];
}
